import { useQuery } from '@tanstack/react-query';
import { fetchActivePromotion } from '../api/promotionService';
import type { Promotion } from '../types/promotion';

export function useActivePromotion() {
  return useQuery<Promotion | null>({
    queryKey: ['promotions', 'active'],
    queryFn: fetchActivePromotion,
  });
}
